@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-card-appraisal/lib/index';
@import '~@adv-mt/mt-card-message/lib/index';
@import '~@adv-mt/mt-form-conditions-and-privacy-checkbox/lib/index';
@import '~@adv-mt/mt-form-sell-vehicle/lib/index';
@import '~@adv-mt/mt-form-user-contact/lib/index';
@import '~@adv-mt/mt-hero-basic/lib/index';
@import '~@adv-mt/mt-list-basic/lib/index';
@import '~@adv-mt/mt-markdown-wrapper/lib/index';
@import '~@adv-mt/mt-navigation-breadcrumb/lib/index';
@import '~@adv-mt/mt-panel-market-players/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-icon/lib/index';
@import '~@s-ui/react-atom-image/lib/index';
@import '~@s-ui/react-form-builder/lib/index';
@import '~@s-ui/react-layout-grid/lib/index';
@import '~@s-ui/react-molecule-accordion/lib/index';
@import '~@s-ui/react-molecule-notification/lib/index';
@import '~@s-ui/react-molecule-quick-action/lib/index';
@import '~@adv-mt/mt-section-basic/lib/index';
@import '~@adv-mt/mt-layout-basic/lib/index';

$mh-landing-financing-main: 38px;

$p-landing-formalities-nested-list: 33px;
$h-landing-financing-skeleton-main: 780px;
$h-landing-financing-skeleton-hero: 160px;

.mt-LandingFormalitiesSecurityGuidelines {
  p {
    color: $c-gray-dark-2;
    margin: 0 0 $m-l;
    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    font-weight: $fw-regular;
  }

  ol {
    color: $c-gray-dark-2;
    padding-left: $p-l;
    li {
      margin: 0 0 $m-l;
    }
  }

  ol ~ ul {
    padding-left: $p-landing-formalities-nested-list;
  }

  &-block {
    background-color: $c-gray-light-2;
    color: $c-gray-dark-2;
    margin-left: $m-l;
    padding: $p-l;
  }

  &-quoted {
    margin: 0 0 $m-l $m-l;

    &:last-child {
      margin-bottom: $m-m;
    }

    @include media-breakpoint-up(s) {
      margin: 0 0 $m-xxl $m-l;
    }
  }

  &-accordionContent {
    padding: $p-m;
  }
  &-skeleton {
    &-hero {
      width: 100%;
      height: $h-landing-financing-skeleton-hero;
      background-color: $c-gray-light-1;
      border-radius: $bdrs-l;
      box-shadow: $bxsh-m;
      margin-top: $m-xl;
    }
    &-main {
      width: 100%;
      height: $h-landing-financing-skeleton-main;
      border-radius: $bdrs-l;
      box-shadow: $bxsh-m;
      margin-top: $m-xl;
    }
  }
}
